import B45_47 from "@images/newGames/B45_57.png"
import B01 from "@images/newGames/B01.png"
import B02 from "@images/newGames/B02.png"
import B03 from "@images/newGames/B03.png"
import B04 from "@images/newGames/B04.png"
import B05 from "@images/newGames/B05.png"
import B06 from "@images/newGames/B06.png"
import B07 from "@images/newGames/B07.png"
import B08 from "@images/newGames/B08.png"
import B09 from "@images/newGames/B09.png"
import B10 from "@images/newGames/B10.png"
import B11 from "@images/newGames/B11.png"
import B12 from "@images/newGames/B12.png"
import B13 from "@images/newGames/B13.png"
import B15 from "@images/newGames/B15.png"
import B18 from "@images/newGames/B18.png"
import B19 from "@images/newGames/B19.png"
import B20 from "@images/newGames/B20.png"
import B21 from "@images/newGames/B21.png"
import B22_23_24 from "@images/newGames/B22_23_24.png"
import B25 from "@images/newGames/B25.png"
import B26 from "@images/newGames/B26.png"
import B27 from "@images/newGames/B27.png"
import B28 from "@images/newGames/B28.png"
import B30 from "@images/newGames/B30.png"
import B31 from "@images/newGames/B31.png"
import B32 from "@images/newGames/B32.png"
import B33 from "@images/newGames/B33.png"
import B34 from "@images/newGames/B34.png"
import B35 from "@images/newGames/B35.png"
import B36 from "@images/newGames/B36.png"
import B37 from "@images/newGames/B37.png"
import B38 from "@images/newGames/B38.png"
import B39 from "@images/newGames/B39.png"
import B40 from "@images/newGames/B40.png"
import B41 from "@images/newGames/B41.png"
import B42 from "@images/newGames/B42.png"
import B43 from "@images/newGames/B43.png"
import B46 from "@images/newGames/B46.png"
import B48 from "@images/newGames/B48.png"
import C2 from "@images/newGames/C2.png"
import X01 from "@images/newGames/X01.png"
import X02 from "@images/newGames/X02.png"
import X03 from "@images/newGames/X03.png"
import X04 from "@images/newGames/X04.png"
import X05 from "@images/newGames/X05.png"
import X06 from "@images/newGames/X06.png"
import X09 from "@images/newGames/X09.png"

const testCreator = i => {
  return {
    title: `游戏名称${i}`,
    booth: `A-${i}`,
    id: "209",
    thumb: B01,
  }
}
export const gamesTest = new Array(25).fill("").map((_, i) => testCreator(i))

export const games = [
  { title: "Terracotta", booth: "b02", id: "57150", thumb: B02 },
  { title: "大救特救", booth: "b03", id: "49947", thumb: B03 },
  { title: "卡库远古封印", booth: "b45 b47", id: "38884", thumb: B45_47 },
  { title: "文字游戏", booth: "b15", id: "51175", thumb: B15 },
  { title: "秘馆疑踪2", booth: "b39", id: "60154", thumb: B39 },
  { title: "午夜幻想曲", booth: "b41", id: "46104", thumb: B41 },
  { title: "96号公路", booth: "b40", id: "54555", thumb: B40 },
  { title: "The Signal State", booth: "b42", id: "60341", thumb: B42 },
  { title: "廖添丁：绝代凶贼之末日", booth: "b09", id: "50932", thumb: B09 },
  { title: "哀歌", booth: "b12", id: "7766", thumb: B12 },
  { title: "凯瑞尔轮回", booth: "b06", id: "56102", thumb: B06 },
  { title: "劲爆51飞行队", booth: "b25", id: "49029", thumb: B25 },
  { title: "骇游侠探", booth: "b26", id: "36793", thumb: B26 },
  { title: "牛车水侦探社", booth: "b27", id: "38119", thumb: B27 },
  { title: "ITORAH", booth: "b28", id: "36599", thumb: B28 },
  { title: "藏梦", booth: "b21", id: "64930", thumb: B21 },
  { title: "猪头三大冒险", booth: "b35", id: "65247", thumb: B35 },
  { title: "山海旅人", booth: "b04", id: "38072", thumb: B04 },
  { title: "蛛丝诡迹", booth: "b05", id: "49960", thumb: B05 },
  { title: "四季之春", booth: "b07", id: "60630", thumb: B07 },
  { title: "听风者也", booth: "b08", id: "63923", thumb: B08 },
  { title: "开普勒斯", booth: "b11", id: "10252", thumb: B11 },
  { title: "Plateman", booth: "b43", id: "65248", thumb: B43 },
  { title: "装甲战线", booth: "b18", id: "50690", thumb: B18 },
  { title: "觉醒者之崛起", booth: "b01", id: "65249", thumb: B01 },
  { title: "噗噗的冒险乐园", booth: "b37", id: "65781", thumb: B37 },
  { title: "命途", booth: "b10", id: "53738", thumb: B10 },
  {
    title: "超逼真的攻城模拟器",
    booth: "b22 b23 b24",
    id: "42429",
    thumb: B22_23_24,
  },
  { title: "轮回深渊", booth: "b19", id: "32419", thumb: B19 },
  { title: "献祭之路", booth: "b13", id: "63094", thumb: B13 },
  { title: "Dwerve", booth: "b48", id: "36090", thumb: B48 },
  { title: "职场浮生记", booth: "b31", id: "65782", thumb: B31 },
  { title: "一方灵田", booth: "b33", id: "40197", thumb: B33 },
  { title: "我的姥爷", booth: "b30", id: "65250", thumb: B30 },
  { title: "Hoa", booth: "b34", id: "54873", thumb: B34 },
  { title: "范式起源", booth: "b46", id: "65783", thumb: B46 },
  {
    title: "ROOT —— Routing.Optimization.Oriented.Terminal",
    booth: "b20",
    id: "65355",
    thumb: B20,
  },
  { title: "在路上", booth: "b32", id: "65784", thumb: B32 },
  { title: "Blood Engine", booth: "X02", id: "62473", thumb: X02 },
  { title: "Hot Pot for One", booth: "X05", id: "50692", thumb: X05 },
  { title: "幻想乡 · 世界", booth: "C2", id: "65251", thumb: C2 },
  { title: "TORCHMAN", booth: "X04", id: "65252", thumb: X04 },
  { title: "双相", booth: "X06", id: "65785", thumb: X06 },
  { title: "倒计世界", booth: "X01", id: "65786", thumb: X01 },
  { title: "渔鱼渔", booth: "X03", id: "65787", thumb: X03 },
  { title: "魔旅之塔", booth: "b38", id: "65387", thumb: B38 },
]
